import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
	selector: "caass-merge-to-group-student-table",
	templateUrl: "./merge-to-group-student-table.component.html",
	styleUrls: ["./merge-to-group-student-table.component.css"],
})
export class MergeToGroupStudentTableComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {
		this.SelectedPersons = this.lstPerson;
	}

	ngOnChanges() {
		this.SelectedPersons = this.lstPerson;
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	// @Output() RemoveAll: EventEmitter<any> = new EventEmitter();
	// @Output() ResetPerson: EventEmitter<any> = new EventEmitter();
	// @Output() RemovePerson: EventEmitter<any> = new EventEmitter();

	@Output() SelectRow: EventEmitter<any> = new EventEmitter();

	///////////////
	// Built-In
	///////////////

	pagerows: any = 5;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPersons: any = [];
	@Input() lstPerson: any = [];

	//Filter lists

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "StudentID", header: "Student ID" },
		{ field: "LastName", header: "Last Name" },
		{ field: "FirstName", header: "First Name" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	// onRemoveAll(){
	//   this.RemoveAll.emit(true);
	// }

	// onResetPerson(){
	//   this.ResetPerson.emit(true);
	// }

	// onRemove(Person){
	//   this.onRowUnselect(null);
	//   this.RemovePerson.emit(Person);
	// }

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.SelectRow.emit(true);
		// this.SelectedPerson = val.data;
	}
	onRowUnselect(val) {
		this.SelectRow.emit(true);
		// this.SelectedPerson = null;
	}
	onRowDblClick(Person) {
		// this.SelectedPerson = Person;
	}
	////////////////////////////////////////////
}
